import type { AcceptInviteResult } from '@qlk/shared';
import { DAI_MAT_KHAU_TOI_THIEU } from '@qlk/shared';
import { ROLE_LABEL } from '@qlk/shared';
import { useMutation } from '@tanstack/react-query';
import { CheckCircle2 } from 'lucide-react';
import { useState } from 'react';
import { Link, useParams } from 'react-router-dom';

import { api, type LoiApi } from '../../../lib/api.js';
import { Nut } from '../../../ui/index.js';

const TOI_THIEU = DAI_MAT_KHAU_TOI_THIEU;

/** Trang công khai: người được mời đặt mật khẩu lần đầu bằng token trong link. */
export function TrangChapNhanLoiMoi() {
  const { token = '' } = useParams<{ token: string }>();

  const [matKhau, setMatKhau] = useState('');
  const [nhacLai, setNhacLai] = useState('');

  const chapNhan = useMutation<AcceptInviteResult, LoiApi, string>({
    mutationFn: (password) =>
      api.post<AcceptInviteResult>(`/api/v1/team/moi/${token}/chap-nhan`, { password }),
  });

  const quaNgan = matKhau.length > 0 && matKhau.length < TOI_THIEU;
  const lechNhau = nhacLai.length > 0 && nhacLai !== matKhau;
  const hopLe = matKhau.length >= TOI_THIEU && nhacLai === matKhau;

  if (chapNhan.data) {
    return (
      <main className="flex min-h-dvh items-center justify-center bg-nen px-4">
        <div className="w-full max-w-md rounded-the border border-vien bg-be-mat p-6 text-center">
          <span
            className="mx-auto mb-3 inline-flex size-12 items-center justify-center rounded-full bg-ok-nen text-ok-chu"
            aria-hidden="true"
          >
            <CheckCircle2 size={24} />
          </span>
          <h1 className="text-tieu-de-hop font-bold text-chu">Đã đặt mật khẩu xong</h1>
          <p className="mt-2 text-co-ban text-chu-phu">
            Tài khoản {chapNhan.data.email} ({ROLE_LABEL[chapNhan.data.roleKey]}) đã sẵn sàng.
          </p>
          <Link
            to="/dang-nhap"
            className="vung-bam mt-5 inline-flex items-center justify-center rounded-[10px] bg-nhan px-4 text-co-ban font-semibold text-white hover:bg-nhan-dam"
          >
            Đăng nhập
          </Link>
        </div>
      </main>
    );
  }

  return (
    <main className="flex min-h-dvh items-center justify-center bg-nen px-4">
      <div className="w-full max-w-md rounded-the border border-vien bg-be-mat p-6">
        <p className="text-phu text-chu-mo">WM Media · Quản lý kênh YouTube</p>
        <h1 className="mt-1 text-tieu-de-trang leading-tight font-bold text-chu">Đặt mật khẩu</h1>
        <p className="mt-2 text-co-ban text-chu-phu">
          Mở link này nghĩa là bạn vừa được mời vào hệ thống, hoặc quản trị vừa đặt lại mật khẩu cho
          bạn. Đặt mật khẩu mới để vào hệ thống.
        </p>

        <form
          className="mt-5 space-y-4"
          onSubmit={(e) => {
            e.preventDefault();
            if (hopLe) chapNhan.mutate(matKhau);
          }}
        >
          <div>
            <label htmlFor="mat-khau" className="mb-1 block text-phu font-medium text-chu-phu">
              Mật khẩu mới
            </label>
            <input
              id="mat-khau"
              type="password"
              autoComplete="new-password"
              value={matKhau}
              onChange={(e) => {
                setMatKhau(e.target.value);
              }}
              className="vung-bam w-full rounded-[10px] border border-vien px-3 text-co-ban text-chu"
            />
            <p className={`mt-1 text-phu ${quaNgan ? 'text-bad-chu' : 'text-chu-mo'}`}>
              Tối thiểu {TOI_THIEU} ký tự.
            </p>
          </div>

          <div>
            <label htmlFor="nhac-lai" className="mb-1 block text-phu font-medium text-chu-phu">
              Nhập lại mật khẩu
            </label>
            <input
              id="nhac-lai"
              type="password"
              autoComplete="new-password"
              value={nhacLai}
              onChange={(e) => {
                setNhacLai(e.target.value);
              }}
              className="vung-bam w-full rounded-[10px] border border-vien px-3 text-co-ban text-chu"
            />
            {lechNhau && <p className="mt-1 text-phu text-bad-chu">Hai lần nhập chưa khớp nhau.</p>}
          </div>

          {chapNhan.isError && (
            <p role="alert" className="rounded-[10px] bg-bad-nen px-3 py-2 text-phu text-bad-chu">
              {chapNhan.error.message}
            </p>
          )}

          <Nut
            kieu="chinh"
            type="submit"
            className="w-full"
            disabled={!hopLe}
            dangChay={chapNhan.isPending}
          >
            Đặt mật khẩu và vào hệ thống
          </Nut>
        </form>
      </div>
    </main>
  );
}
